import { ClearAllCacheFromIndexedDB } from "../../../IndexedDB/CacheIndexedDB";
import { CheckIndexedDBIsSupport } from "../../../IndexedDB/tabIndexedDB";
import { SetMerchantChannel } from "../../../broadcastChannel/merchantChannel";
import { CheckBroadcastIsSupport } from "../../../broadcastChannel/tabChannel";
import { BroadcastReCreateTab, SetUserChannel } from "../../../broadcastChannel/userChannel";
import Enums from "../../../enums/enums";
import userInfo from "../../../function/userInfo";
import {
  AddAccessTokenCache,
  AddSelectedMerchantCache,
  AddUserProfileCache,
  GetSelectedMerchantFromCache,
  GetUserProfileFromCache,
} from "../../../helper/cacheHelper";
import mainHelper from "../../../helper/mainHelper";
import { SocketConnect } from "../../../helper/notificationHelper";
import settingHelper from "../../../helper/settingHelper";
import shareHelper from "../../../helper/shareHelper";
import { ClearMasterTabFromCookies, InsertTabIdToTabDB, UpdateTabMerchantId } from "../../../helper/tabHelper";
import userHelper from "../../../helper/userHelper";
import i18n from "../../../locales/i18n";
import router from "../../../router";
import * as api from "../../../service/ApiSevice";
import { analytics, event } from "../../../service/analytics/analytics";
import merchantFacade from "../../../service/merchant/merchantFacade";
import userFacade from "../../../service/user/userFacade";
import store from "../../baseController";
export const actions = {
  RemoveCookiesToken({ state, commit }) {
    userInfo.RemoveCookiesToken();
  },
  clean_login({ state, commit }) {
    analytics.emitEvent(event.action.unidentify);
    return api.UserService.DoGetNewAccessTokenByRefreshToken().then((res) => {
      if (res.status.IsSuccess()) {
        let idToken = res.data.id_token;
        let userId = state.userModel.userId.PeakEncryption();
        return api.UserService.DoRevokeToken(idToken, userId).then((resRevokeToken) => {
          commit("MutationSetLoginstatus", Enums.LoadingStatusType.None);
          userInfo.RemoveCookiesToken();
          sessionStorage.removeItem("emi");
          return resRevokeToken;
        });
      } else {
        commit("MutationSetLoginstatus", Enums.LoadingStatusType.None);
        userInfo.RemoveCookiesToken();
        sessionStorage.removeItem("emi");
        return res;
      }
    });
  },
  updateEmi({ commit }, message) {
    commit("MtUpdateEmi", message);
  },
  login_email({ commit, state }, message) {
    let encpw = message.password;
    if (message.userType == Enums.userType.email) {
      encpw = shareHelper.CreateToken(message.password);
    }
    commit("MutationSetLoginstatus", Enums.LoadingStatusType.Loading);
    let source = Enums.ActivityLogSource.PEAK_Experience;
    const iss = message.iss || "";
    api.UserService.DoGetAccessToken(message.username, encpw, message.userType, source, iss).then(
      async (resAccessToken) => {
        commit("MutationGetAlertLoginOldPassword", { notify_password: resAccessToken.data.notify_password || false });
        if (resAccessToken.status.IsSuccess()) {
          const responseCode = resAccessToken.data.response_code
            ? resAccessToken.data.response_code
            : Enums.HttpStatusCode.OK;

          analytics.emitEvent(event.submit.login, {
            language: i18n.locale,
            loginFormProperties: message,
            succeeded: responseCode.IsSuccess(),
          });
          if (responseCode.IsSuccess()) {
            await AddAccessTokenCache(resAccessToken.data.access_token);
            //check KeepLogin
            if (message.keepLogin) {
              userInfo.SetCookiesKeepLogin();
              userInfo.SetCookiesAccessToken(resAccessToken.data.access_token);
              userInfo.SetCookiesRefreshToken(resAccessToken.data.refresh_token, true);
            } else {
              userInfo.SetCookiesAccessToken(resAccessToken.data.access_token);
              userInfo.SetCookiesRefreshToken(resAccessToken.data.refresh_token);
            }

            const userModel = await store.dispatch("DoGetUserInfoByUserIdFromServiceAsync");
            if (userModel.userId > 0) {
              analytics.emitEvent(event.action.identify, userModel);
              commit("loginSuccess", userModel);
              ClearMasterTabFromCookies();
              if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
                await InsertTabIdToTabDB();
                SetUserChannel(userModel.userId);
                BroadcastReCreateTab();
              }
              commit("MutationSetLoginstatus", Enums.LoadingStatusType.Success);
              if (message.register) {
                router.push({ name: "welcome" });
              } else {
                if (
                  resAccessToken.data.is_new_password_hashing !== undefined &&
                  !resAccessToken.data.is_new_password_hashing
                ) {
                  if (!resAccessToken.data.notify_password) {
                    mainHelper.HandleLoginLastUrlNavigation();
                  }
                } else {
                  mainHelper.HandleLoginLastUrlNavigation();
                }
              }
            }
          } else {
            let loginStatus = Enums.LoadingStatusType.Failed;

            if (
              [Enums.userType.google, Enums.userType.microsoft].includes(message.userType) &&
              responseCode === Enums.HttpStatusCode.Moved
            ) {
              store.dispatch("SetAlertMessage", {
                alertMessage: i18n.t("Alert_Login_Google_Fail"),
                typeMessage: Enums.TypeComponentNoti.error,
              });
              router.push({ name: "register" });
              loginStatus = Enums.LoadingStatusType.None;
            }
            commit("MutationSetLoginstatus", loginStatus);
            userInfo.RemoveCookiesToken();
          }
        } else {
          commit("MutationSetLoginstatus", Enums.LoadingStatusType.Failed);
          userInfo.RemoveCookiesToken();
          analytics.emitEvent(event.submit.login, {
            language: i18n.locale,
            loginFormProperties: message,
            succeeded: false,
          });
        }
      }
    );
  },
  async authorizeModels({ commit, state }) {
    let refresh_token = userInfo.GetRefreshToken();
    if (refresh_token) {
      let userProfile = state.userModel;
      if (userProfile == null) {
        userProfile = await GetUserProfileFromCache();
        if (userProfile != null) {
          commit("MutationSetLoginstatus", Enums.LoadingStatusType.Loading);
          setTimeout(async () => {
            commit("loginSuccess", userProfile);
            if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
              await InsertTabIdToTabDB();
              SetUserChannel(userProfile.userId);
            }
            SocketConnect();
            commit("MutationSetLoginstatus", Enums.LoadingStatusType.Success);
          });
        } else {
          commit("MutationSetLoginstatus", Enums.LoadingStatusType.Loading);
          await store.dispatch("IsLoading", true);
          setTimeout(async () => {
            const userModel = await store.dispatch("DoGetUserInfoByUserIdFromServiceAsync");
            if (userModel.userId > 0) {
              commit("loginSuccess", userModel);
              if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
                await InsertTabIdToTabDB();
                SetUserChannel(userModel.userId);
              }
              SocketConnect();
              commit("MutationSetLoginstatus", Enums.LoadingStatusType.Success);
            } else {
              router.push("/SessionExpire");
            }
          });
        }
      }
    } else {
      router.push("/logout");
    }
  },
  DoGetUserDetailForDisplay({ commit, state }, userIdList) {
    return new Promise((resolve) => {
      if (state.otherUserListLoadingStatus !== Enums.LoadingStatusType.Loading) {
        commit("MutationOtherUserListLoadingStatus", Enums.LoadingStatusType.Loading);
        userIdList = [...new Set(userIdList)];
        let userIdForSearch = [];

        if (state.otherUserList && state.otherUserList.length > 0) {
          userIdList.forEach((userId) => {
            let userIdOnLocal = state.otherUserList.find((x) => x.userId === userId);
            if (!userIdOnLocal) {
              userIdForSearch.push(userId);
            }
          });
        } else {
          userIdForSearch = userIdList;
        }
        userIdForSearch = userIdForSearch.filter((item) => {
          return item !== null && item !== undefined;
        });

        if (userIdForSearch.length > 0) {
          api.UserService.DoGetUserDetailForDisplay(userIdList).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const userDetailList = userFacade.ConvertToUserDetailList(res.data.userDetailList);
              commit("MutationUserDetailForDisplay", userDetailList);
            }
            commit("MutationOtherUserListLoadingStatus", Enums.LoadingStatusType.Success);
            resolve(state.otherUserList);
          });
        } else {
          setTimeout(() => {
            commit("MutationOtherUserListLoadingStatus", Enums.LoadingStatusType.Success);
            resolve(state.otherUserList);
          }, 0);
        }
      }
    });
  },
  DoGetAllUserDetailForDisplayByMerchantId({ commit, state }) {
    return new Promise((resolve) => {
      state.userListInMerchantLoadingStatus = Enums.LoadingStatusType.Loading;
      if (state.userListInMerchant && state.userListInMerchant.length > 0) {
        setTimeout(() => {
          state.userListInMerchantLoadingStatus = Enums.LoadingStatusType.Success;
          resolve(state.userListInMerchant);
        }, 250);
      } else {
        api.UserService.DoGetAllUserDetailListForDisplayByMerchantId().then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const userDetailList = userFacade.ConvertToUserDetailList(res.data.userDetailList);
            commit("MutationAllUserDetailForDisplayByMerchantId", userDetailList);
          }
          resolve(state.userListInMerchant);
          state.userListInMerchantLoadingStatus = Enums.LoadingStatusType.Success;
        });
      }
    });
  },
  DoGetMerchantList({ commit, state }) {
    if (state.merchantListLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetMerchantListLoadingStatus", Enums.LoadingStatusType.Loading);
      store.dispatch("IsLoading", true);
      api.MerchantService.DoGetMerchantListByUserId().then((resMerchant) => {
        if (resMerchant.status.IsSuccess()) {
          const merchantList = merchantFacade.ConvertToMerchantList(resMerchant.data.merchantList);
          const demoOrganize = merchantList.find((x) => x.isSample);
          commit("MutationSetDemoOrganize", demoOrganize ? demoOrganize : null);
          commit("MutationSetMerchantList", merchantList);
          commit("MutationSetMerchantListLoadingStatus", Enums.LoadingStatusType.Success);
          store.dispatch("IsLoading", false);
        }
      });
    }
  },
  DoGetAccessToken({ commit, state }, userName) {
    api.UserService.DoGetAccessToken(userName)
      .then(async (res) => {
        if (res.status.IsSuccess()) {
          await AddAccessTokenCache(res.data.access_token);
          const keepLogin = userInfo.GetKeepLogin();
          userInfo.SetCookiesAccessToken(res.data.access_token);
          userInfo.SetCookiesRefreshToken(res.data.refresh_token, keepLogin);
        } else {
          router.push("/logout");
        }
      })
      .catch((err) => {});
  },
  DoGetNewAccessTokenByRefreshToken({ commit, state }) {
    return new Promise((resolve) => {
      api.UserService.DoGetNewAccessTokenByRefreshToken().then(async (res) => {
        if (res.status.IsSuccess()) {
          const keepLogin = userInfo.GetKeepLogin();
          await ClearAllCacheFromIndexedDB();
          await AddAccessTokenCache(res.data.access_token);
          userInfo.SetCookiesAccessToken(res.data.access_token);
          userInfo.SetCookiesRefreshToken(res.data.refresh_token, keepLogin);
          resolve(true);
        } else {
          location.href = `${window.location.origin}/SessionExpire`;
          resolve(false);
        }
      });
    });
  },

  DoIntrospectAccessToken({ commit, state }) {
    return new Promise((resolve) => {
      api.UserService.DoIntrospectAccessToken().then(async (res) => {
        if (res.status.IsSuccess() && res.data.active) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  },
  DoRefreshMerchantList({ commit, state }) {
    return api.UserService.DoRefreshMerchantList().then((res) => {
      if (res.status.IsSuccess()) {
        return true;
      } else {
        router.push("/SessionExpire");
        return false;
      }
    });
  },
  DoGetUserInfoByUserId({ commit, state }) {
    return new Promise(async (resolve, reject) => {
      store.dispatch("IsLoading", true);
      commit("MutationSetGetUserInfoByUserIdLoadingStatus", Enums.LoadingStatusType.Loading);
      const userModel = await store.dispatch("DoGetUserInfoByUserIdFromServiceAsync");
      if (userModel.userId > 0) {
        commit("loginSuccess", userModel);
        commit("MutationSetLoginstatus", Enums.LoadingStatusType.Success);
      }
      store.dispatch("IsLoading", false);
      commit("MutationSetGetUserInfoByUserIdLoadingStatus", Enums.LoadingStatusType.Success);
      resolve();
    });
  },
  DoGetUserInfoByUserIdFromServiceAsync({ commit, state }) {
    return new Promise((resolve, reject) => {
      api.UserService.DoGetUserInfoByUserId().then(async (resUser) => {
        if (resUser.status.IsSuccess()) {
          const userModel = userHelper.ConvertToUserModel(resUser.data.userInfo);
          await AddUserProfileCache(userModel);
          resolve(userModel);
        } else {
          resolve(userModel);
        }
      });
    });
  },
  DoSelectMerchant({ commit, state }, input) {
    return new Promise(async (resolve, reject) => {
      if (state.selectMerchantLodingStatus !== Enums.LoadingStatusType.Loading) {
        commit("MutationsSetSelectMerchantLodingStatus", Enums.LoadingStatusType.Loading);
        store.dispatch("IsLoading", true);
        const selectedMerchantFromCache = await GetSelectedMerchantFromCache(input.merchantId);
        if (selectedMerchantFromCache && selectedMerchantFromCache.merchantId > 0) {
          store.dispatch("IsLoading", false);
          if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
            SetMerchantChannel(selectedMerchantFromCache.merchantId);
            UpdateTabMerchantId(selectedMerchantFromCache.merchantId);
          }
          commit("MutationsSelectMerchant", selectedMerchantFromCache);
          commit("MutationsSetSelectMerchantLodingStatus", Enums.LoadingStatusType.Success);
        } else {
          api.MerchantService.DoGetSelectedMerchant(input.merchantId, input.isUseMainDatabase).then(
            async (resMerchant) => {
              if (resMerchant.status.IsSuccess() && resMerchant.data.responseCode.IsSuccess()) {
                store.dispatch("IsLoading", false);
                const selectMerchant = userHelper.GetSelectedMerchant(resMerchant.data.merchant);
                await AddSelectedMerchantCache(selectMerchant);
                if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
                  SetMerchantChannel(selectMerchant.merchantId);
                  UpdateTabMerchantId(selectMerchant.merchantId);
                }
                commit("MutationsSelectMerchant", selectMerchant);
              } else {
                commit("MutationsSelectMerchant", null);
              }
              commit("MutationsSetSelectMerchantLodingStatus", Enums.LoadingStatusType.Success);
            }
          );
        }
      }
    });
  },
  DoGetMerchantByResetCache({ commit, state }, input) {
    return new Promise(async (resolve, reject) => {
      commit("MutationsGetMerchantByResetCacheLoadingStatus", Enums.LoadingStatusType.Loading);
      store.dispatch("IsLoading", true);
      const selectedMerchantFromCache = await GetSelectedMerchantFromCache(input.merchantId);
      if (selectedMerchantFromCache && selectedMerchantFromCache.merchantId > 0) {
        commit("MutationsSelectMerchant", selectedMerchantFromCache);
        setTimeout(() => {
          store.dispatch("IsLoading", false);
          commit("MutationsGetMerchantByResetCacheLoadingStatus", Enums.LoadingStatusType.Success);
          resolve(selectedMerchantFromCache);
        }, 250);
      } else {
        api.MerchantService.DoGetSelectedMerchant(input.merchantId, input.isUseMainDatabase).then(
          async (resMerchant) => {
            if (resMerchant.status.IsSuccess() && resMerchant.data.responseCode.IsSuccess()) {
              const selectMerchant = userHelper.GetSelectedMerchant(resMerchant.data.merchant);
              await AddSelectedMerchantCache(selectMerchant);
              commit("MutationsSelectMerchant", selectMerchant);
              resolve(selectMerchant);
            } else {
              commit("MutationsSelectMerchant", null);
              resolve(null);
            }
            store.dispatch("IsLoading", false);
            commit("MutationsGetMerchantByResetCacheLoadingStatus", Enums.LoadingStatusType.Success);
            resolve();
          }
        );
      }
    });
  },
  DoGet2ndLogin({ commit, state }) {
    if (state.get2ndLoginLodingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationsGet2ndLoginLodingStatus", Enums.LoadingStatusType.Loading);
      store.dispatch("IsLoading", true);
      api.UserService.DoGet2ndLogin().then((res) => {
        if (res.status.IsSuccess()) {
          store.dispatch("IsLoading", false);
          commit("MutationsGet2ndLogin", res.data.is2ndLogin);
          commit("MutationsGet2ndLoginLodingStatus", Enums.LoadingStatusType.Success);
        }
      });
    }
  },
  DoSet2ndLogin({ commit, state }) {
    if (state.set2ndLoginLodingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationsSet2ndLoginLodingStatus", Enums.LoadingStatusType.Loading);
      store.dispatch("IsLoading", true);
      api.UserService.DoSet2ndLogin().then((res) => {
        if (res.status.IsSuccess()) {
          store.dispatch("IsLoading", false);
          commit("MutationsSet2ndLoginLodingStatus", Enums.LoadingStatusType.Success);
        }
      });
    }
  },
  DoGetRefreshTokenExpiration({ commit, state }) {
    if (state.refreshTokenExpirationLodingStatus !== Enums.LoadingStatusType.Loading) {
      let refreshToken = userInfo.GetRefreshToken();
      if (refreshToken) {
        commit("MutationsSetRefreshTokenExpirationLodingStatus", Enums.LoadingStatusType.Loading);
        store.dispatch("IsLoading", true);
        api.UserService.DoGetRefreshTokenExpiration().then((res) => {
          if (res.status.IsSuccess()) {
            const lastUrl = mainHelper.GetLastUrl();
            if (lastUrl) {
              mainHelper.DeleteLastUrl();
              window.location.href = lastUrl;
            } else {
              router.push({ name: "selectlist" });
            }
          } else {
            store.dispatch("RemoveCookiesToken");
          }
          store.dispatch("IsLoading", false);
          commit("MutationsSetRefreshTokenExpirationLodingStatus", Enums.LoadingStatusType.Success);
        });
      } else {
        store.dispatch("RemoveCookiesToken");
      }
    }
  },
  DoClearToken({ commit, state }, userId) {
    if (state.refreshTokenExpirationLodingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationsClearTokenLodingStatus", Enums.LoadingStatusType.Loading);
      api.UserService.DoClearToken(userId).then((res) => {
        if (res.status.IsSuccess()) {
          store.dispatch("RemoveCookiesToken");
          router.push({ name: "logout", query: { logout: true } });
        }
        store.dispatch("IsLoading", false);
        commit("MutationsClearTokenLodingStatus", Enums.LoadingStatusType.Success);
      });
    }
  },
  DoClearAllToken({ commit, state }, token) {
    if (state.refreshTokenExpirationLodingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationsClearAllTokenLodingStatus", Enums.LoadingStatusType.Loading);
      api.UserService.DoClearAllToken(token).then((res) => {
        store.dispatch("IsLoading", false);
        if (res.status.IsSuccess()) {
          commit("MutationClearAllToken", res.data);
          commit("MutationsClearAllTokenLodingStatus", Enums.LoadingStatusType.Success);
        } else {
          commit("MutationsClearAllTokenLodingStatus", Enums.LoadingStatusType.Failed);
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
        }
      });
    }
  },
  DoGetFavoriteMerchant({ commit, state }) {
    if (state.getFavoriteMerchantListLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetFavoriteMerchantListLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoGetFavoriteMerchant().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          commit("MutationSetFavoriteMerchantList", res.data.merchantFavorite);
        } else {
          const alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
        }
        commit("MutationSetFavoriteMerchantListLoadingStatus", Enums.LoadingStatusType.Success);
      });
    }
  },
  DoUpdateFavoriteMerchant({ commit, state }, merchantId) {
    if (state.updateFavoriteMerchantLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetUpdateFavoriteMerchantLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoUpdateFavoriteMerchant(merchantId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          commit("MutationSetUpdateFavoriteMerchantLoadingStatus", Enums.LoadingStatusType.Success);
          commit("MutationSetFavoriteMerchantListLoadingStatus", Enums.LoadingStatusType.None);
        } else {
          const alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
        }
      });
    }
  },
  DoDeleteFavoriteMerchant({ commit, state }, merchantId) {
    if (state.deleteFavoriteMerchantLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetDeleteFavoriteMerchantLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoDeleteFavoriteMerchant(merchantId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          commit("MutationSetDeleteFavoriteMerchantLoadingStatus", Enums.LoadingStatusType.Success);
          commit("MutationSetFavoriteMerchantListLoadingStatus", Enums.LoadingStatusType.None);
        } else {
          const alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
        }
      });
    }
  },
  DoDeletePackageRecurringForDeleteMerchant() {
    return new Promise((resolve, reject) => {
      api.PackageService.DoGetPackageRecurring()
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            if (res.data.recurring) {
              const reasons = [{ id: Enums.ReasonCancelSubscriptionType.Others, detail: "ลบอัตโนมัติจากหน้าลบกิจการ" }];
              api.PackageService.DoDeletePackageRecurring(reasons)
                .then((res) => {
                  if (res.data.responseCode.IsSuccess()) {
                    store.dispatch("SetAlertMessage", {
                      alertMessage: i18n.t("Cancel_Subscription_Success"),
                      typeMessage: Enums.TypeComponentNoti.success,
                    });
                    resolve();
                  } else {
                    reject(res.data.exception);
                  }
                })
                .catch((err) => reject(err));
            } else {
              resolve();
            }
          } else {
            reject(res.data.exception);
          }
        })
        .catch((err) => reject(err));
    });
  },

  DoDeleteUserTokenForDeleteMerchant() {
    return new Promise((resolve, reject) => {
      api.MerchantService.DoGetMerchantSettingApiPartnerUserToken()
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const merchantSettingApiPartnerUserToken = merchantFacade.GetMerchantSettingApiPartnerUserToken(
              res.data.apiPartnerUserTokenList
            );
            for (const tokenSetting of merchantSettingApiPartnerUserToken) {
              if (tokenSetting.userTokenList.length) {
                for (const userToken of tokenSetting.userTokenList) {
                  const input = {
                    userTokenId: userToken.userTokenId,
                    apiPartnerType: tokenSetting.apiPartnerType,
                  };
                  api.MerchantService.DoRemoveMerchantSettingApiPartnerUserToken(input).then((res) => {
                    if (res.data.responseCode.IsSuccess()) {
                      store.dispatch("SetAlertMessage", {
                        alertMessage: i18n.t("Disconnect_Success", {
                          name: settingHelper.GetConnectPartnerAppTypeName(input.apiPartnerType),
                        }),
                        typeMessage: Enums.TypeComponentNoti.success,
                      });
                      resolve();
                    } else {
                      reject(res.data.exception);
                    }
                  });
                }
              }
            }
            resolve();
          } else {
            reject(res.data.exception);
          }
        })
        .catch((err) => reject(err));
    });
  },
  DoGetAndDeleteUserTokenForDeleteMerchant() {
    const getAndDeleteBentoWebUserToken = new Promise((resolve, reject) => {
      api.MerchantService.DoGetTokenDataBentoWeb()
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            if (res.data.data) {
              api.MerchantService.DoDeleteTokenBentoWeb()
                .then((res) => {
                  if (res.data.responseCode.IsSuccess()) {
                    store.dispatch("SetAlertMessage", {
                      alertMessage: i18n.t("Disconnect_Success", { name: "Bento Web" }),
                      typeMessage: Enums.TypeComponentNoti.success,
                    });
                    resolve();
                  } else {
                    reject(res.data.exception);
                  }
                })
                .catch((err) => reject(err));
            } else {
              resolve();
            }
          } else {
            reject(res.data.exception);
          }
        })
        .catch((err) => reject(err));
    });
    const getAndDeletePage365UserToken = new Promise((resolve, reject) => {
      api.MerchantService.DoGetTokenDataPage365()
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            if (res.data.data) {
              api.MerchantService.DoDeleteTokenPage365()
                .then((res) => {
                  if (res.data.responseCode.IsSuccess()) {
                    store.dispatch("SetAlertMessage", {
                      alertMessage: i18n.t("Disconnect_Success", { name: "Page365" }),
                      typeMessage: Enums.TypeComponentNoti.success,
                    });
                    resolve();
                  } else {
                    reject(res.data.exception);
                  }
                })
                .catch((err) => reject(err));
            } else {
              resolve();
            }
          } else {
            reject(res.data.exception);
          }
        })
        .catch((err) => reject(err));
    });
    const getAndDeleteLineMyShopUserToken = new Promise((resolve, reject) => {
      api.MerchantService.DoGetTokenDataLineMyShop()
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            if (res.data.data) {
              api.MerchantService.DoDeleteTokenLineMyShop()
                .then((res) => {
                  if (res.data.responseCode.IsSuccess()) {
                    store.dispatch("SetAlertMessage", {
                      alertMessage: i18n.t("Disconnect_Success", { name: "LINE SHOPPING" }),
                      typeMessage: Enums.TypeComponentNoti.success,
                    });
                    resolve();
                  } else {
                    reject(res.data.exception);
                  }
                })
                .catch((err) => reject(err));
            } else {
              resolve();
            }
          } else {
            reject(res.data.exception);
          }
        })
        .catch((err) => reject(err));
    });
    const getAndDeleteShopeeToken = new Promise((resolve, reject) => {
      const tokensToDelete = [];
      api.MerchantService.DoGetTokenDataShopee()
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            if (res.data.data.length) {
              for (const tokenData of res.data.data) {
                tokensToDelete.push(
                  new Promise((resolve, reject) => {
                    api.MerchantService.DoDeleteTokenShopee(tokenData.shopId)
                      .then((res) => {
                        if (res.data.responseCode.IsSuccess()) {
                          store.dispatch("SetAlertMessage", {
                            alertMessage: i18n.t("Disconnect_Success", { name: "Shopee" }),
                            typeMessage: Enums.TypeComponentNoti.success,
                          });
                          resolve();
                        } else {
                          reject(res.data.exception);
                        }
                      })
                      .catch((err) => reject(err.data.exception));
                  })
                );
              }
            } else {
              resolve();
            }
            if (tokensToDelete.length) {
              Promise.all(tokensToDelete)
                .then(() => resolve())
                .catch((err) => reject(err));
            } else {
              resolve();
            }
          } else {
            reject(res.data.exception);
          }
        })
        .catch((err) => reject(err));
    });
    const getAndDeleteLazadaToken = new Promise((resolve, reject) => {
      const tokensToDelete = [];
      api.MerchantService.DoGetTokenDataLazada()
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            if (res.data.data.length) {
              for (const tokenData of res.data.data) {
                tokensToDelete.push(
                  new Promise((resolve, reject) => {
                    api.MerchantService.DoDeleteTokenLazada(tokenData.sellerId)
                      .then((res) => {
                        if (res.data.responseCode.IsSuccess()) {
                          store.dispatch("SetAlertMessage", {
                            alertMessage: i18n.t("Disconnect_Success", { name: "Lazada" }),
                            typeMessage: Enums.TypeComponentNoti.success,
                          });
                          resolve();
                        } else {
                          reject(res.data.exception);
                        }
                      })
                      .catch((err) => reject(err));
                  })
                );
              }
            } else {
              resolve();
            }
          } else {
            reject(res.data.exception);
          }
          if (tokensToDelete.length) {
            Promise.all(tokensToDelete)
              .then(() => resolve())
              .catch((err) => reject(err));
          } else {
            resolve();
          }
        })
        .catch((err) => reject(err));
    });
    return new Promise((resolve, reject) => {
      Promise.all([
        getAndDeleteBentoWebUserToken,
        getAndDeletePage365UserToken,
        getAndDeleteLineMyShopUserToken,
        getAndDeleteShopeeToken,
        getAndDeleteLazadaToken,
      ])
        .then(() => resolve())
        .catch((err) => reject(err));
    });
  },
  DoDeleteQRPaymentSettingForDeleteMerchant() {
    let paymentModel = {
      bayQRPaymentCodeModel: null,
      bblQRPaymentCodeModel: null,
      beamPaymentModel: null,
      chillPayPaymentCodeModel: null,
      paySolutionPaymentModel: null,
      scbQRPaymentCodeModel: null,
    };
    return new Promise((resolve, reject) => {
      api.MerchantService.DoGetQRPaymentSetting()
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            if (res.data.data) {
              paymentModel.bayQRPaymentCodeModel = res.data.data.bayQRPaymentCodeModel;
              paymentModel.bblQRPaymentCodeModel = res.data.data.bblQRPaymentCodeModel;
              paymentModel.beamPaymentModel = res.data.data.beamPaymentModel;
              paymentModel.chillPayPaymentCodeModel = res.data.data.chillPayPaymentCodeModel;
              paymentModel.paySolutionPaymentModel = res.data.data.paySolutionPaymentModel;
              paymentModel.scbQRPaymentCodeModel = res.data.data.scbQRPaymentCodeModel;
              for (const payment in paymentModel) {
                if (paymentModel[payment]) {
                  let input = "";
                  let name = "";
                  switch (payment) {
                    case "bayQRPaymentCodeModel":
                      input = Enums.ApiQRPaymentType.Bay;
                      name = "Krungsri Bill Payment Collection";
                      break;
                    case "bblQRPaymentCodeModel":
                      input = Enums.ApiQRPaymentType.Bbl;
                      name = "BBL QR Collection";
                      break;
                    case "beamPaymentModel":
                      input = Enums.ApiQRPaymentType.Beam;
                      name = "Beam";
                      break;
                    case "chillPayPaymentCodeModel":
                      input = Enums.ApiQRPaymentType.ChillPay;
                      name = "ChillPay";
                      break;
                    case "paySolutionPaymentModel":
                      input = Enums.ApiQRPaymentType.PaySolutions;
                      name = "Pay Solutions";
                      break;
                    case "scbQRPaymentCodeModel":
                      input = Enums.ApiQRPaymentType.SCB;
                      name = "SCB QR Payment";
                      break;
                  }
                  api.MerchantService.DoVoidQrPaymentCode(input)
                    .then((res) => {
                      if (res.data.responseCode.IsSuccess()) {
                        store.dispatch("SetAlertMessage", {
                          alertMessage: i18n.t("Disconnect_Success", { name: name }),
                          typeMessage: Enums.TypeComponentNoti.success,
                        });
                        resolve();
                        return;
                      } else {
                        reject(res.data.exception);
                        return;
                      }
                    })
                    .catch((err) => reject(err));
                } else {
                  resolve();
                }
              }
            } else {
              resolve();
            }
          }
        })
        .catch((err) => reject(err));
    });
  },
  DoDeleteMerchant({ commit, state }, merchantName) {
    if (state.deleteFavoriteMerchantLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetDeleteMerchantLoadingStatus", Enums.LoadingStatusType.Loading);
      store.dispatch("IsLoading", true);
      Promise.all([
        store.dispatch("DoDeletePackageRecurringForDeleteMerchant"),
        store.dispatch("DoDeleteUserTokenForDeleteMerchant"),
        store.dispatch("DoGetAndDeleteUserTokenForDeleteMerchant"),
        store.dispatch("DoDeleteQRPaymentSettingForDeleteMerchant"),
      ])
        .then(() => {
          api.MerchantService.DoDeleteMerchant(merchantName).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              setTimeout(() => {
                router.push({ name: "selectlist" });
              }, 5000);
            } else {
              const alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
              store.dispatch("SetAlertMessage", {
                alertMessage: alertMessage,
                typeMessage: Enums.TypeComponentNoti.error,
              });
            }
            commit("MutationSetDeleteMerchantLoadingStatus", Enums.LoadingStatusType.Success);
          });
        })
        .catch((err) => {
          const alertMessage = shareHelper.GetErrorMessageByExceptionCode(err);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationSetDeleteMerchantLoadingStatus", Enums.LoadingStatusType.Failed);
        })
        .finally(() => {
          store.dispatch("IsLoading", false);
        });
    }
  },
  DoCheckIsCreatedMerchantNotSample({ commit, state }, isUseMainDatabase = false) {
    if (state.checkIsCreatedMerchantNotSampleLoadingStatus !== Enums.LoadingStatusType.Loading) {
      store.dispatch("IsLoading", true);
      commit("MutationSetCheckIsCreatedMerchantNotSampleLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoCheckIsCreatedMerchantNotSample(isUseMainDatabase).then((res) => {
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          commit("MutationSetIsCreatedMerchantNotSample", res.data.isCreatedMerchantNotSample);
        } else {
          const alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
        }
        commit("MutationSetCheckIsCreatedMerchantNotSampleLoadingStatus", Enums.LoadingStatusType.Success);
        store.dispatch("IsLoading", false);
      });
    }
  },
  DoGetMerchantModelById({ commit, state }, merchantId) {
    return new Promise(async (resolve) => {
      commit("MutationSetMerchantModelByIdLoadingStatus", Enums.LoadingStatusType.Loading);
      let merchantModelOnLocal = null;
      merchantModelOnLocal = state.merchantModelListForMap.get(merchantId);

      if (merchantModelOnLocal) {
        setTimeout(() => {
          commit("MutationSetMerchantModelByIdLoadingStatus", Enums.LoadingStatusType.Success);
          resolve({ ...merchantModelOnLocal.merchant });
        }, 0);
      } else {
        const selectedMerchantFromCache = await GetSelectedMerchantFromCache(merchantId);
        if (selectedMerchantFromCache && selectedMerchantFromCache.merchantId > 0) {
          store.dispatch("IsLoading", false);
          commit("MutationSetMerchantModelList", { merchantId: merchantId, merchant: selectedMerchantFromCache });
          resolve({ ...selectedMerchantFromCache });
          commit("MutationSetMerchantModelByIdLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          api.MerchantService.DoGetSelectedMerchant(merchantId, false).then(async (resMerchant) => {
            if (resMerchant.status.IsSuccess() && resMerchant.data.responseCode.IsSuccess()) {
              store.dispatch("IsLoading", false);
              const merchant = userHelper.GetSelectedMerchant(resMerchant.data.merchant);
              await AddSelectedMerchantCache(merchant);
              commit("MutationSetMerchantModelList", { merchantId: merchantId, merchant: merchant });
              resolve({ ...merchant });
            } else {
              commit("MutationSetMerchantModelList", { merchantId: merchantId, merchant: null });
              resolve(null);
            }
            commit("MutationSetMerchantModelByIdLoadingStatus", Enums.LoadingStatusType.Success);
          });
        }
      }
    });
  },
};
